export const ru = {
    company_name_header: 'Компания',
    tp_header: 'Тревел-политика',
    company_name_placeholder: 'Название компании',
    choose_tp_placeholder: 'Выберите тревел-политику',
    tp_add_success: 'Тревел-политика успешно обновлена',
    tp_add_error: 'Не удалось обновить тревел-политику',
};
